import { HotelReserveRoomsFilterItem } from "@website/accommodation-ui/hotel-reserve-rooms-filter/hotel-reserve-rooms-filter-item/hotel-reserve-rooms-filter-item";
import { HotelReserveRoomsFilterPropertiesType } from "@website/accommodation-ui/hotel-reserve-rooms-filter/hotel-reserve-rooms-filter.types";
import { deepCompare } from "@website/utils/deep-compare";
import isEmpty from "lodash-es/isEmpty";
import { memo } from "react";

const Component = ({ roomsFilter }: HotelReserveRoomsFilterPropertiesType) => (
  <div className="flex flex-row items-center gap-4 overflow-x-auto pt-10 md:overflow-x-visible">
    {!isEmpty(roomsFilter) &&
      roomsFilter?.map((roomFilter) => (
        <HotelReserveRoomsFilterItem {...roomFilter} />
      ))}
  </div>
);
export const HotelReserveRoomsFilter = memo(Component, deepCompare);
